<template>
    <div>
        <div class="title">{{ $t("invoice.invoiceTitle") }}</div>
        <div class="mline"></div>
        <div>
            <div class="h_center">
                <!-- <input type="radio" v-model="invoiceType" value="0" class="radioclass"> -->
                <span class="pay-type-item-icon" @click="selectV('0')"><i :class="{active:invoiceType==0?true:false}"></i></span>
                <label>{{ $t("invoice.invoiceType0") }}</label>
                <!-- <input type="radio" v-model="invoiceType" value="1" class="radioclass" style="margin-left:120px"> -->
                <span class="pay-type-item-icon" @click="selectV('1')" style="margin-left:120px"><i :class="{active:invoiceType==1?true:false}"></i></span>
                <label>{{ $t("invoice.invoiceType1") }}</label>
                <!-- <input type="radio" v-model="invoiceType" value="2" class="radioclass" style="margin-left:120px"> -->
                <span class="pay-type-item-icon" @click="selectV('2')" style="margin-left:120px"><i :class="{active:invoiceType==2?true:false}"></i></span>
                <label>{{ $t("invoice.invoiceType2") }}</label>
            </div>
            <div class="h_main">
                <div style="margin-top:20px" v-show="invoiceType!='0'">
                    <label style="width:200px;margin-left:30px;">{{ $t("invoice.invName") }}</label>
                    <label style="margin-left:55px">{{regConfig.cfgInvTitle}}</label>
                </div>
                <div style="margin-top:20px" v-show="invoiceType=='1'">
                    <label style="margin-left:30px;display:inline-block" :class="{ch_mg_inv:locale=='ch',en_mg_inv:locale=='en'}">{{ $t("invoice.invRegTitle") }}</label>
                    <input type="text" value="" :placeholder='$t("invoice.invRegTitle")'  v-model="regInvTitle" />
                    <span class="err-msg" v-if="(regInvTitle==''||regInvTitle==null) && dirty1 && invoiceType=='1'">{{ $t("invoice.input") }}{{ $t("invoice.invRegTitle") }}</span>
                </div>
            </div>
            <div class="h_main" v-show="invoiceType=='2'">
                <div class="title">{{ $t("invoice.VAT") }}</div>
                <div class="mline"></div>
                <div class="info-item" style="margin-top:20px">
                    <label style="margin-left:30px;" :class="{L7:locale=='ch',ch_mg_vat:locale=='ch',en_mg_vat:locale=='en'}">{{ $t("invoice.invAddOrg") }}</label>
                    <input type="text" value="" :placeholder='$t("invoice.invAddOrg")' style="margin-left:20px" v-model="valueadd_invoice.regInvOrg" />
                    <div v-if="(valueadd_invoice.regInvOrg==null ||valueadd_invoice.regInvOrg == '') && dirty2 && invoiceType=='2' " class="err-msg">{{ $t("invoice.input") }}{{ $t("invoice.invAddOrg") }}</div>
                </div>
                <div class="info-item" style="margin-top:20px">
                    <label style="margin-left:30px" :class="{L7:locale=='ch',ch_mg_vat:locale=='ch',en_mg_vat:locale=='en'}">{{ $t("invoice.invAddTax") }}</label>
                    <input type="text" value="" :placeholder='$t("invoice.invAddTax")' style="margin-left:20px" v-model="valueadd_invoice.regInvTax" />
                    <div v-if="(valueadd_invoice.regInvTax==null || valueadd_invoice.regInvTax == '') && dirty2 && invoiceType=='2'" class="err-msg">{{ $t("invoice.input") }}{{ $t("invoice.invAddTax") }}</div>
                </div>
                <div class="info-item" style="margin-top:20px">
                    <label style="margin-left:30px;" :class="{L7:locale=='ch',ch_mg_vat:locale=='ch',en_mg_vat:locale=='en'}">{{ $t("invoice.invAddAddr") }}</label>
                    <input type="text" value="" :placeholder='$t("invoice.invAddAddr")' style="margin-left:20px" v-model="valueadd_invoice.regInvAddr" />
                    <div v-if="(valueadd_invoice.regInvAddr==null || valueadd_invoice.regInvAddr == '') && dirty2 && invoiceType=='2'" class="err-msg">{{ $t("invoice.input") }}{{ $t("invoice.invAddAddr") }}</div>
                </div>
                <div class="info-item" style="margin-top:20px">
                    <label style="margin-left:30px;" :class="{L7:locale=='ch',ch_mg_vat:locale=='ch',en_mg_vat:locale=='en'}">{{ $t("invoice.invAddTel") }}</label>
                    <input type="text" value="" :placeholder='$t("invoice.invAddTel")' style="margin-left:20px" v-model="valueadd_invoice.regInvTel" />
                    <div v-if="(valueadd_invoice.regInvTel==null ||valueadd_invoice.regInvTel== '') && dirty2 && invoiceType=='2'" class="err-msg">{{ $t("invoice.input") }}{{ $t("invoice.invAddTel") }}</div>
                </div>
                <div class="info-item" style="margin-top:20px">
                    <label style="margin-left:30px;" :class="{L7:locale=='ch',ch_mg_vat:locale=='ch',en_mg_vat:locale=='en'}">{{ $t("invoice.invAddBank") }}</label>
                    <input type="text" value="" :placeholder='$t("invoice.invAddBank")' style="margin-left:20px" v-model="valueadd_invoice.regInvBank" />
                    <div v-if="(valueadd_invoice.regInvBank==null || valueadd_invoice.regInvBank == '') && dirty2 && invoiceType=='2'" class="err-msg">{{ $t("invoice.input") }}{{ $t("invoice.invAddBank") }}</div>
                </div>
                <div class="info-item" style="margin-top:20px">
                    <label style="margin-left:30px;" :class="{L7:locale=='ch',ch_mg_vat:locale=='ch',en_mg_vat:locale=='en'}">{{ $t("invoice.invAddAcount") }}</label>
                    <input type="text" value="" :placeholder='$t("invoice.invAddAcount")' style="margin-left:20px" v-model="valueadd_invoice.regInvAccount" />
                    <div v-if="(valueadd_invoice.regInvAccount==null || valueadd_invoice.regInvAccount == '') && dirty2 && invoiceType=='2'" class="err-msg">{{ $t("invoice.input") }}{{ $t("invoice.invAddAcount") }}</div>
                </div>
                <div class="info-item" style="margin-top:40px">
                    <label style="margin-left:30px;">{{ $t("invoice.taxpayer") }}</label>
                </div>
                <div class="info-item" style="" v-if="regConfig.cfgInvUploadFl=='1'">
                    <div class="file-box" style="text-align:center;display: inline-block;">
                        <div class="preview" :style="bdPreview">
                        </div>
                        <input @change="changeFile()" type="file" id="file">
                    </div>
                    <div style="width: 400px;text-align:center;margin-left: 30px;padding-top:5px;color:red;font-size:14px">
                        <span v-show="previewSrc!=''">{{ $t("invoice.uploadReImg") }}</span>
                        <span v-show="previewSrc==''">{{ $t("invoice.uploadImg") }}</span>
                    </div>
                    <div v-if="(bdPreview==null || bdPreview=='') && dirty2 && invoiceType=='2'" class="err-msg">{{ $t("invoice.uptaxpayer") }}</div>
                </div>
            </div>
        </div>
        <div v-show="invoiceType!='0' && regConfig.cfgInvAddressFl=='1'">
            <div class="title">{{ $t("invoice.invGetTitle") }}</div>
            <div class="mline"></div>
            <div style="margin-top:20px">
                <label style="margin-left:30px;display:inline-block" :class="{ch_mg_inv:locale=='ch',en_mg_inv:locale=='en'}">{{ $t("invoice.invGetName") }}</label>
                <input type="text" value="" :placeholder='$t("invoice.invGetName")' v-model="invoice_contact.contactName" />
                <span class="err-msg" v-if="(invoice_contact.contactName==null || invoice_contact.contactName=='') && dirty3">{{$t("invoice.input")}}{{$t("invoice.invGetName")}}</span>
            </div>
            <div style="margin-top:20px">
                <label style="margin-left:30px;display:inline-block" :class="{ch_mg_inv:locale=='ch',en_mg_inv:locale=='en'}">{{ $t("invoice.invGetPhone") }}</label>
                <input type="text" value="" :placeholder='$t("invoice.invGetPhone")' maxlength="11" v-model="invoice_contact.contactPhone" />
                <span class="err-msg" v-if="(invoice_contact.contactPhone==null || invoice_contact.contactPhone=='') && dirty3">{{$t("invoice.input")}}{{$t("invoice.invGetPhone")}}</span>
            </div>
            <div style="margin-top:20px">
                <label style="margin-left:30px;display:inline-block" :class="{ch_mg_inv:locale=='ch',en_mg_inv:locale=='en'}">{{ $t("invoice.invGetAddr") }}</label>
                <input type="text" value=""  :placeholder='$t("invoice.invGetAddr")' v-model="invoice_contact.contactAddr" />
                <span class="err-msg" v-if="(invoice_contact.contactAddr==null || invoice_contact.contactAddr=='') && dirty3">{{$t("invoice.input")}}{{$t("invoice.invGetAddr")}}</span>
            </div>
            <div style="color:#00AAEE;font-size:14px;margin-top:30px;margin-left:30px;" v-html="regConfig.cfgInvoiceDesc"></div>
        </div>
        <div class="title">{{ $t("invoice.conTitle") }}</div>
        <div class="mline"></div>
        <div style="margin-top:20px">
            <label style="margin-left:30px;" :class="{ch_mg_contact:locale=='ch',en_mg_contact:locale=='en'}">{{ $t("invoice.conPerson") }}</label>
            <label>{{cPerson}}</label>
        </div>
        <div style="margin-top:20px">
            <label style="width:200px;margin-left:30px">{{ $t("invoice.conPhone") }}</label>
            <label>{{cPhone}}</label>
        </div>
        <div class="foot">
            <button class="btn" @click="goPre" v-show="opFlag!='1'">{{ $t("btn.pre") }}</button>
            <button class="btn" :class="[canNext ? 'err-bounce':'']" @click="goNext">{{ $t("btn.next") }}</button>
        </div>
    </div>
</template>
<script>
export default {
    data() {
            return {
                info: {},
                invoice: {},
                dirty1: false, //p普通发票表单是否为脏
                dirty2: false, //增值税发票表单是否为脏
                dirty3: false, //发票联系人表单
                canNext: false, //是否可以跳转到下一页
                previewSrc: '', //图片预览地址
                invoiceType: 0, //发票类型
                regConfig: {},
                regInvTitle: '', //发票抬头
                //增值税发票
                valueadd_invoice: {
                    regInvOrg: '', //单位名称
                    regInvTax: '', //纳税人识别码
                    regInvAddr: '',
                    regInvTel: '', //注册电话
                    regInvBank: '', //开户银行
                    regInvAccount: '', //银行账户
                },
                //发票联系人
                invoice_contact: {
                    contactName: '',
                    contactPhone: '',
                    contactAddr: '',
                },
                opFlag: '', //标识是修改操作
                cPerson: '',
                cPhone: '',
                locale: '',
            }
        },
        computed: {
            bdPreview() {
                let src = this.previewSrc;
                if (!src) return '';
                return {
                    'background-image': 'url(' + src + ')'
                }
            }
        },
        mounted() {
            this.locale = localStorage.getItem("locale");
            this.info = JSON.parse(sessionStorage.getItem("info"));
            this.cPerson = this.info.conference.cPerson;
            this.cPhone = this.info.conference.cPhone;
            this.regConfig = this.info.reg_config;
            this.invoice = JSON.parse(sessionStorage.getItem("invoice"));
            this.opFlag = this.$route.params.opFlag;
            if (this.invoice != null) {
                this.previewSrc = this.invoice.regInvLicenseImg;
                this.invoiceType = this.invoice.regInvoiceType;
                this.regInvTitle = this.invoice.regInvTitle;
                this.invoice_contact.contactName = this.invoice.regInvoiceContact;
                this.invoice_contact.contactPhone = this.invoice.regInvoicePhone;
                this.invoice_contact.contactAddr = this.invoice.regInvoiceAddr;
                this.valueadd_invoice.regInvOrg = this.invoice.regInvOrg;
                this.valueadd_invoice.regInvTax = this.invoice.regInvTax;
                this.valueadd_invoice.regInvAddr = this.invoice.regInvAddr;
                this.valueadd_invoice.regInvTel = this.invoice.regInvTel;
                this.valueadd_invoice.regInvBank = this.invoice.regInvBank;
                this.valueadd_invoice.regInvAccount = this.invoice.regInvAccount;
            }
        },
        methods: {
            //        上一步
            goPre() {
                this.$router.push('/sign/hotel');
            },
            selectV: function(flag) {
                if (flag == 0) {
                    this.invoiceType = 0;
                } else if (flag == 1) {
                    this.invoiceType = 1;
                } else if (flag == 2) {
                    this.invoiceType = 2;
                }
            },
            /**
             * 校验表单增值税发票
             * @returns {number}
             */
            regForm() {
                let errnum = 0;
                this.dirty = true;
                for (let item in this.valueadd_invoice) {

                    if (this.valueadd_invoice[item] != null && this.valueadd_invoice[item].trim().length == 0) {
                        errnum++;
                    }
                }
                if (this.bdPreview == '') {
                    errnum++;
                }
                return errnum;
            },

            regForm3() {
                let errnum = 0;
                this.dirty3 = true;
                for (let item in this.invoice_contact) {
                    if (this.invoice_contact[item].trim().length === 0) {
                        errnum++;
                    }
                    if (item == "contactPhone" && !this.validateMobile(this.invoice_contact[item])) {
                        this.invoice_contact[item] = '';
                        errnum++;
                    }
                }
                return errnum;
            },
            /**
             * 校验普通发票
             */
            regForm2() {
                let errnum = 0;
                if (this.regInvTitle != '' && this.regInvTitle != null && this.regInvTitle.trim().length > 0) {
                    return 0;
                } else {
                    return 1;
                }
            },
            goPre: function() {
                this.$router.push('/sign/hotel/0');
            },
            //        进入到下一步
            goNext: function() {
                let regId = "";
                let userStore = JSON.parse(localStorage.getItem('user'));

                let uid = userStore.uId;
                if (this.opFlag == '1') {
                    regId = JSON.parse(sessionStorage.getItem('invoice')).regId;
                } else {
                    regId = JSON.parse(sessionStorage.getItem('payInfo')).data.register.regId;
                }
                //如果是普通发票

                if (this.invoiceType == '1' && this.regForm2() > 0) {
                    this.dirty1 = true;
                    this.canNext = true;
                    setTimeout(() => {
                        this.canNext = false;
                    }, 400);
                    return;
                }
                //          如果是增值发票，表单检验
                if (this.invoiceType == '2' && this.regForm() > 0) {
                    this.dirty2 = true;
                    this.canNext = true;
                    setTimeout(() => {
                        this.canNext = false;
                    }, 400);
                    return;
                }
                //校验发票联系人
                // alert(this.invoiceType+","+this.regConfig.cfgInvAddressFl)
                if (this.invoiceType != '0' && this.regConfig.cfgInvAddressFl == '1' && this.regForm3() > 0) {
                    this.dirty3 = true;
                    this.canNext = true;
                    setTimeout(() => {
                        this.canNext = false;
                    }, 400);
                    return;
                }

                let param = {
                    "uid": uid,
                    "regid": regId,
                    "inv_type": this.invoiceType,
                    "inv_title": this.regInvTitle,
                    "inv_org": this.valueadd_invoice.regInvOrg,
                    "inv_taxpayer": this.valueadd_invoice.regInvTax,
                    "inv_reg_addr": this.valueadd_invoice.regInvAddr,
                    "inv_reg_tel": this.valueadd_invoice.regInvTel,
                    "inv_bank": this.valueadd_invoice.regInvBank,
                    "inv_account": this.valueadd_invoice.regInvAccount,
                    "inv_contact": this.invoice_contact.contactName,
                    "inv_phone": this.invoice_contact.contactPhone,
                    "inv_addr": this.invoice_contact.contactAddr
                };

                let formdata = new FormData();
                let filed = document.getElementById('file').files[0];
                formdata.append('file', filed);
                /*let imgParam = {
                 header:{
                 'Content-Type':'multipart/form-data'
                 },
                 };*/

                let postUrl = '/medapp/api/common/upload/34/' + regId + '/' + uid;

                this.postHttp('/medapp/api/template/register/invoice/add', param).then((result) => {
                    if (this.invoiceType == '1' || this.invoiceType == '0') {
                        if (this.opFlag == 1) {
                            this.$router.push('/order/info');
                        } else {
                            this.$router.push('/sign/morder');
                        }

                        return false;
                    } else {
                        if (filed) {
                            axios.post(postUrl, formdata).then((result) => {
                                if (this.opFlag == 1) {
                                    this.$router.push('/order/info');
                                } else {
                                    this.$router.push('/sign/morder');
                                }
                            })
                        } else {
                            if (this.opFlag == 1) {
                                this.$router.push('/order/info');
                            } else {
                                this.$router.push('/sign/morder');
                            }
                        }

                    }

                });
            },
            //      上传图片
            changeFile() {
                let file = document.getElementById('file');
                let fileObj = file.files[0];
                let reader = new FileReader();
                reader.addEventListener("load", () => {
                    this.previewSrc = reader.result;
                }, false);

                if (fileObj) {
                    reader.readAsDataURL(fileObj);
                }

            }
        }
}
</script>
<style scoped>
.err-bounce {
    animation: err-bounce ease-in .3s;
}

@keyframes err-bounce {
    0% {
        transform: translateX(-20px);
    }
    10% {
        transform: translateX(20px);
    }
    20% {
        transform: translateX(-15px);
    }
    30% {
        transform: translateX(15px);
    }
    40% {
        transform: translateX(-10px);
    }
    50% {
        transform: translateX(10px);
    }
    60% {
        transform: translateX(-5px);
    }
    70% {
        transform: translateX(5px);
    }
    100% {
        transform: translateX(0);
    }
}

.ch_mg_inv{
    display: inline-block;
    width:100px;
}
.en_mg_inv{
    display: inline-block;
    width:130px;
}

.ch_mg_vat{
    display: inline-block;
    width:200px;
}
.en_mg_vat{
    display: inline-block;
    width:180px;
}
.ch_mg_contact{
    display: inline-block;
    width:65px;
}
.en_mg_contact{
    display: inline-block;
    width:155px;
}

.info-item {
    position: relative;
}

.err-msg {
    color: red;
    display: inline-block;
    margin-left: 12px;
}

.err-msg.file-msg {
    width: 400px;
    padding-left: 40px;
    text-align: center;
}

.file-box {
    width: 400px;
    height: 250px;
    margin-left: 30px;
    margin-top: 10px;
    position: relative;
    background-repeat: no-repeat;
    background-color: #eee;
    background-position: center center;
    background-size: 100px 100px;
    background-image: url(./photo.png);
}


/*模拟单选框begin*/

.pay-type-item-icon {
    font-size: 0;
    border: 1px solid #B5B5B5;
    display: inline-block;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
}

.pay-type-item-icon i {
    display: inline-block;
    padding: 5px;
    background-color: #FFFFFF;
    border-radius: 50%;
}

.pay-type-item-icon i.active {
    background-color: #F39800;
}

.L7 {
    letter-spacing: .7em;
    margin-right: -.7em
}


/*模拟单选框end*/

.preview {
    width: 100%;
    height: 100%;
    z-index: 1;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
}

.file-box input#file {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
}

.title {
    font-size: 18px;
    color: #000;
    font-weight: 600;
    margin-top: 40px;
}

.mline {
    height: 1px;
    width: 100%;
    background: #DCDCDC;
    margin-top: 5px;
}

.h_center {
    margin-top: 20px;
    text-align: center;
}

.radioclass {
    height: 20px;
    width: 20px;
    margin: 3px 10px 3px 5px;
    vertical-align: middle;
}

.radioclass:checked {
    background: #F39900;
}

.h_center label {
    font-size: 16px;
    font-weight: 500;
    color: #000;
}

.h_main {
    margin-top: 30px;
}

.ht_name_circle {
    width: 220px;
    height: 40px;
    border-radius: 30px;
    outline: none;
    border: 1px solid #cfcfcf;
    color: #000;
    background-color: #FFF;
    font-size: 16px;
    margin-right: 30px;
}

label {
    font-size: 16px;
    color: #000;
    margin-right: 10px;
}

.h_dt select {
    height: 30px;
    width: 120px;
    border-radius: 30px;
    outline: none;
    padding-left: 10px;
    font-size: 16px;
    border: 1px solid #cfcfcf;
}

input {
    width: 300px;
    height: 35px;
    line-height: 35px;
    border-radius: 30px;
    font-size: 15px;
    padding-left: 20px;
    margin-left: 20px;
    border: 1px solid #cfcfcf;
    outline: none;
}

.ht_room_circle {
    width: 120px;
    height: 30px;
    border-radius: 30px;
    outline: none;
    border: 1px solid #cfcfcf;
    color: #000;
    background-color: #FFF;
    font-size: 16px;
    margin-right: 30px;
}

input::placeholder {
    font-size: 14px
}

.btn {
    width: 200px;
    height: 50px;
    border-radius: 30px;
    outline: none;
    border: 0;
    color: #FFF;
    background-color: #33D0C2;
    font-size: 18px;
    margin-right: 30px;
    cursor: pointer;
}

.foot {
    text-align: center;
    margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// invoice.vue?3ef88f26